import React from 'react';
import { useRecorrencias } from './Context';
import { useParamsContext } from '../../contexts/ParamsContext';
import { AgendaForm } from '../agenda/estabelecimento/Form/Form';
import { RecorrenciasList } from './List';

const Recorrencias = () => {
    const { action, clear } = useParamsContext();
    const { loadRecorrencias } = useRecorrencias();

    switch (action) {
        case 'add':
            return (
                <div className="pb-10">
                    <AgendaForm
                        recurrenceMode
                        redirectOnCreate={false}
                        onDone={() => {
                            loadRecorrencias();
                            clear();
                        }}
                    />
                </div>
            );
        default:
            return <RecorrenciasList />;
    }
};

export default Recorrencias;
